import { HomeStudentViewSection } from '@/components/HomeStudentViewSection';
import Constants from '@/Constants';
import { ContentRequest } from '@/models/ContentRequest';
import { CourseRequest } from '@/models/CourseResquest';
import { getViewTypeData, ViewType } from '@/models/ViewType';
import { courseService } from '@/services/CourseService';
import { ApplicationState } from '@/store';
import { getContentListRequest } from '@/store/item/action';
import { ItemTypes } from '@/store/item/types';
import { coursesClear, coursesRequest } from '@/store/list/action';
import { ListTypes } from '@/store/list/types';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const VIEW_TYPE_OF_SECTION: ViewType = 'listInProgressStudentView';
const InProgressStudantSection: React.FC = () => {
    const dispatch = useDispatch();
    const { strings, modules, person, coursesListData, contentListData } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        modules: state.appOrganization.data.modules,
        person: state.identity.data.person,
        coursesListData: state.lists.listData[VIEW_TYPE_OF_SECTION],
        contentListData: state.itens.listData[VIEW_TYPE_OF_SECTION],
    }));

    const { title, resource } = useMemo(() => {
        return getViewTypeData(VIEW_TYPE_OF_SECTION);
    }, [strings._LANGUAGE]);

    const loadCourses = useCallback(() => {
        dispatch(
            coursesRequest({
                personId: person.id,
                section: 'IN_PROGRESS',
                excludeExpiredAndNotFinished: true,
                courseStatus: Constants.courseEnrollmentStatus.STARTED,
                lessonStatus: Constants.contentEnrollmentStatus.INCOMPLETE,
                moduleIds: courseService.getModuleIdsForRequest(modules, [Constants.PLAYLIST_MODULE_ID, Constants.LMS_MODULE_ID]),

                paginationData: {
                    offset: coursesListData.list.length,
                    limit: Constants.COURSE_SECTION_PAGINATION_LIMIT,
                    orderBy: 'cen.startDate desc',
                    doRequest: true,
                    courseRequestSuccessType: ListTypes.IN_PROGRESS_SUCCESS,
                },
            } as CourseRequest),
        );
    }, [dispatch, person.id, coursesListData.list.length]);

    const loadContent = useCallback(() => {
        dispatch(
            getContentListRequest({
                personId: person.id,
                contentEnrollmentStatus: Constants.contentEnrollmentStatus.INCOMPLETE,
                listTypeParm: 'IN_PROGRESS',
                paginationData: {
                    limit: 2,
                    doRequest: true,
                    orderBy: 'cone.lastAccess desc',
                    offset: contentListData.list.length,
                    contentRequestSuccessType: ItemTypes.IN_PROGRESS_SUCCESS,
                },
            } as ContentRequest),
        );
    }, [person.id, contentListData.list.length]);

    const clear = useCallback(() => {
        dispatch(coursesClear());
    }, [dispatch]);

    useEffect(loadCourses, []);

    useEffect(loadContent, []);

    useEffect(() => clear, [dispatch]);

    return (
        <HomeStudentViewSection
            onLoadMoreSlideContent={loadCourses}
            seeAllPath={`/${Constants.SECTIONS_RESOURCE_NAME}/${resource}`}
            title={title}
            viewType={VIEW_TYPE_OF_SECTION}
        />
    );
};

export { InProgressStudantSection };
